import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';

@Component({
    selector: 'stupa-map-options-drawer',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './map-options-drawer.component.html',
    styleUrl: './map-options-drawer.component.scss'
})
export class MapOptionsDrawerComponent implements OnInit, OnDestroy {
    @Input() location: string = '';
    @Output() panelClose = new EventEmitter<void>();
    @Output() openMap = new EventEmitter<'google' | 'apple'>();

    private readonly host: HTMLElement = inject(ElementRef).nativeElement;
    private readonly document = inject(DOCUMENT);

    /**
     * The drawer is `position: fixed`, but tournament cards can render inside a CDK virtual-scroll
     * viewport whose transform would pin it to the list instead of the screen — so it lives on <body>.
     */
    ngOnInit(): void {
        this.document.body.appendChild(this.host);
    }

    /** Removed here too: when the owning card is destroyed, Angular only detaches the card's own element. */
    ngOnDestroy(): void {
        this.host.remove();
    }

    onClose(event?: MouseEvent) {
        if (event) {
            event.stopPropagation();
        }
        this.panelClose.emit();
    }

    onOpenMap(type: 'google' | 'apple', event: MouseEvent) {
        event.stopPropagation();
        this.openMap.emit(type);
    }
}
